import type { TUseGetSocialApplyByStatusResponse } from "@api";
import type { SocialApplyStatus } from "@bbj-types/socialApply/enum";
import type { ObjectId } from "@bbj-types/utils";
import type { Dispatch, ReactNode, SetStateAction } from "react";
import { createContext, useContext, useMemo } from "react";
import type { TSocialOfferTab } from "./logics";

interface ICandidatesListContext {
  total: number;
  applies?: TUseGetSocialApplyByStatusResponse<TSocialOfferTab>["data"];
  setApplies: Dispatch<SetStateAction<TUseGetSocialApplyByStatusResponse<TSocialOfferTab>["data"] | undefined>>;
  socialApplySelected: ObjectId[];
  setSocialApplySelected: Dispatch<SetStateAction<ObjectId[]>>;
  changeTab: (tab: SocialApplyStatus) => void;
}

const Context = createContext<ICandidatesListContext>({
  total: 0,
  applies: undefined,
  setApplies: () => {},
  socialApplySelected: [],
  setSocialApplySelected: () => {},
  changeTab: () => {},
});

export const useCandidatesListContext = () => useContext(Context);

interface ICandidatesListProviderProps {
  total: number;
  applies?: TUseGetSocialApplyByStatusResponse<TSocialOfferTab>["data"];
  setApplies: Dispatch<SetStateAction<TUseGetSocialApplyByStatusResponse<TSocialOfferTab>["data"] | undefined>>;
  socialApplySelected: ObjectId[];
  setSocialApplySelected: Dispatch<SetStateAction<ObjectId[]>>;
  changeTab: (tab: SocialApplyStatus) => void;
  children: ReactNode;
}
export const CandidatesListProvider = ({
  total,
  applies,
  setApplies,
  socialApplySelected,
  setSocialApplySelected,
  changeTab,
  children,
}: ICandidatesListProviderProps) => {
  const value = useMemo(
    () => ({ total, applies, setApplies, socialApplySelected, setSocialApplySelected, changeTab }),
    [total, applies, setApplies, socialApplySelected, setSocialApplySelected, changeTab]
  );

  return <Context.Provider value={value}>{children}</Context.Provider>;
};
